<div class="part3">

    <div id="carouselSlides_part3" class="screen-div carousel slide" data-interval="false">

        <ol class="carousel-indicators top-indicators" id="top-indicators-div">
            <li data-target="#carouselSlides_part3"
                *ngFor="let frameContentIndicators of frameContents; let i = index; let isFirst = first"
                [ngClass]="{active:isFirst}" [attr.data-slide-to]="i" class="indicator-content">
                <img [src]="baseURL + frameContentIndicators.imgUrl" [id]="'frameContents' + i"
                    (click)="scrollToById('frameContents' + i)" data-aos="flip-left">
            </li>
        </ol>
   
        <div class="carousel-inner">
            <div *ngFor="let frameContent of frameContents; let i = index; let isFirst = first" class="carousel-item"
                [ngClass]="{active : isFirst}">
                <img class="fame-content" [src]="baseURL + frameContent.imgUrl">
                <img class="frame-screen" [src]="baseURL + 'frame-screen.png'">

                <div *ngFor="let contentLbl of frameContent.lable; let ci = index" class="content-lable"
                    [ngClass]="[i === 0 ? 'content-' + i + '-lable-' + ci : 'content-lable-default']">
                    <div class="content-txt"> {{contentLbl}} </div>
                    <div class="line"></div>
                </div>

                <div [hidden]="i === 0">
                    <a class="carousel-control-prev arrow arrow-prev" href="#carouselSlides_part3" role="button"
                        data-slide="next">
                        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                        <!-- <span class="sr-only">Previous</span> -->
                    </a>
                    <a class="carousel-control-next arrow arrow-next" href="#carouselSlides_part3" role="button"
                        data-slide="prev">
                        <span class="carousel-control-next-icon" aria-hidden="true"></span>
                        <!-- <span class="sr-only">Next</span> -->
                    </a>
                </div>

            </div>
        </div>

        <div [hidden]="true">
            <a class="carousel-control-prev arrow arrow-prev" href="#carouselSlides_part3" role="button"
                data-slide="next">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <!-- <span class="sr-only">Previous</span> -->
            </a>
            <a class="carousel-control-next arrow arrow-next" href="#carouselSlides_part3" role="button"
                data-slide="prev">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <!-- <span class="sr-only">Next</span> -->
            </a>
        </div>

    </div>


</div>